import { FormattersTypes } from '@/services/types/formatter'


export default ({ vtag, component, data, key }: FormattersTypes) => {
  component.tag = 'span';
  return vtag('div', {class: 'class-name'}, [data[key]]);
}
